import React, { useState, useEffect, useRef } from "react";
import { useField } from "formik";
import styles from "./ImageUploader.module.scss";
import crossBtn1 from "../../../static/icons/crossBtn1.svg";
import PhotoCrop from "../../PhotoCrop";
import defaultPlusIcon from "../../../static/images/plus.svg";
import PhotoCropRectangular from "../../PhotoCropRectangular/index";
import pencilIcon from "../../../static/icons/pencilwithbackground.svg";

const ImageUploaderV4 = ({
  placeholder,
  preview,
  closeButton,
  isCircled = true,
  withCrop,
  uploadPhoto,
  preloadPhoto,
  message,
  hideControls,
  variant,
  plusIcon = defaultPlusIcon,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const [croppedImage, setCroppedImage] = useState(false);
  const [canOpen, setCanOpen] = useState(false);
  const inputRef = useRef(null);
  const [image, setImage] = useState(() => {
    return field.value
      ? field.value.url
        ? field.value.url
        : URL.createObjectURL(field.value)
      : null;
  });

  useEffect(() => {
    if (preloadPhoto instanceof Blob) {
      setCroppedImage(true);
      const url_image = URL.createObjectURL(preloadPhoto);
      setImage(url_image);
      helpers.setValue(new File([preloadPhoto], "avatar.png"));
    }
  }, [preloadPhoto]);

  const attachImage = (event) => {
    const type = event.type;
    let image = null;
    if (type === "change") {
      image = [...event.target.files][0];
      setCanOpen(true);
    }
    helpers.setValue(image);
    setImage(URL.createObjectURL(image));
    setCroppedImage(false);
    event.preventDefault();
  };

  const resetValue = () => {
    helpers.setValue(null);
    setImage(null);
  };
  const onCloseCrop = () => {
    resetValue();
    setCroppedImage(true);
  };
  const onSaveCrop = (imgData) => {
    setImage(URL.createObjectURL(imgData.topopup));
    helpers.setValue(new File([imgData.tosave], "avatar.png"));
    setCroppedImage(true);
  };

  if (canOpen && image && !croppedImage) {
    if (props.hasOwnProperty("isRectangular")) {
      return (
        <PhotoCropRectangular
          image={image}
          onCloseCrop={onCloseCrop}
          onSaveCrop={onSaveCrop}
          setCroppedImage={setCroppedImage}
          isCircled={true}
          isPost={uploadPhoto}
          withCrop={withCrop}
          modalTitle={
            (placeholder || "").toString().toUpperCase() || "COVER IMAGE"
          }
          modalSubtitle={
            message || "Resize and adjust your picture before saving."
          }
        />
      );
    } else {
      return (
        <PhotoCrop
          image={image}
          onCloseCrop={onCloseCrop}
          onSaveCrop={onSaveCrop}
          setCroppedImage={setCroppedImage}
          isCircled={true}
          isPost={uploadPhoto}
          withCrop={withCrop}
          modalTitle={(placeholder || "PROFILE PICTURE")
            .toString()
            .toUpperCase()}
          modalSubtitle={
            message || "Resize and adjust your picture before saving."
          }
        />
      );
    }
  }

  return (
    <label
      className={`${styles.ImageUploader} ${variant ? styles[variant] : ""}`}
      invalid={meta.touched ? meta.error : undefined}
      filled={field.value}
    >
      {field.value ? (
        uploadPhoto ? (
          <>
            <div className={styles.uploadImage}>
              <img src={image} alt="" />
              {closeButton && (
                <button
                  type="button"
                  className={styles.resetButton}
                  onClickCapture={resetValue}
                >
                  <img src={crossBtn1} alt="crossBtn" />
                </button>
              )}
              {closeButton && hideControls && (
                <span aria-hidden="true">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="3"
                    height="22"
                    viewBox="0 0 3 22"
                    fill="none"
                  >
                    <path
                      d="M1.5 1.25L1.5 21.25"
                      stroke="#0A0B0C"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              )}
            </div>
          </>
        ) : (
          <>
            <div
              className={styles.image}
              style={{
                backgroundImage: `url(${image})`,
              }}
              alt=""
            />
            {!hideControls && (
              <button
                type="button"
                className={styles.resetButton}
                onClick={() => inputRef.current && inputRef.current.click()}
              >
                <img src={pencilIcon} alt="edit" />
              </button>
            )}
            {hideControls && (
              <span aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="3"
                  height="22"
                  viewBox="0 0 3 22"
                  fill="none"
                >
                  <path
                    d="M1.5 1.25L1.5 21.25"
                    stroke="#0A0B0C"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            )}
          </>
        )
      ) : preview ? (
        <>
          <div className={styles.uploadImage}>
            <img src={preview} alt="" />
          </div>
          {!hideControls && (
            <button
              type="button"
              className={styles.resetButton}
              onClick={() => inputRef.current && inputRef.current.click()}
            >
              <img src={pencilIcon} alt="edit" />
            </button>
          )}
          {hideControls && (
            <span aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="3"
                height="22"
                viewBox="0 0 3 22"
                fill="none"
              >
                <path
                  d="M1.5 1.25L1.5 21.25"
                  stroke="#0A0B0C"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          )}
        </>
      ) : (
        <>
          {props.hasOwnProperty("isRectangular") ? (
            <>
              <div
                className={styles.labelTextRectangular}
                data-label-text="labelBlock"
              >
                <span className={styles.imagePlaceholderRectangular}>
                  {placeholder || ""}
                  <br />
                  {message || ""}
                </span>
                <img src={plusIcon} alt="add" />
              </div>
            </>
          ) : (
            <>
              <div className={styles.labelText} data-label-text="labelBlock">
                <span className={styles.imagePlaceholder}>
                  {placeholder || ""}
                  <br />
                  {message || ""}
                </span>
                <img src={plusIcon} alt="add" />
              </div>
            </>
          )}
        </>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={attachImage}
      />
    </label>
  );
};
export default ImageUploaderV4;
